import * as utils from '../../utils/schoolUtils'
import { Timestamp } from 'firebase/firestore'

export class Teacher {
  constructor({
    name,
    joinDate,
    staffType,
    staffCode,
    dob,
    gender,
    aadhaarNo,
    gmail,
    mobNo,
    lastSchool,
    otherSchoolExp,
    houseName,
    locality,
    place,
    postOffice,
    taluk,
    pinCode,
    district,
    academicQualification,
    teachingQualification,
    otherQualification,
    bankAccNo,
    bankName,
    ifsc,
    esicNo,
    epfUan,
    panNo,
  } = {}) {
    this.name = name;
    this.joinDate = joinDate;
    this.staffType = staffType;
    this.staffCode = staffCode;
    this.dob = dob;
    this.gender = gender;
    this.aadhaarNo = aadhaarNo;
    this.gmail = gmail;
    this.mobNo = mobNo;
    this.lastSchool = lastSchool;
    this.otherSchoolExp = otherSchoolExp;
    this.houseName = houseName;
    this.locality = locality;
    this.place = place;
    this.postOffice = postOffice;
    this.taluk = taluk;
    this.pinCode = pinCode;
    this.district = district;
    this.academicQualification = academicQualification;
    this.teachingQualification = teachingQualification;
    this.otherQualification = otherQualification;
    this.bankAccNo = bankAccNo;
    this.bankName = bankName;
    this.ifsc = ifsc;
    this.esicNo = esicNo;
    this.epfUan = epfUan;
    this.panNo = panNo;
  }

  static fromMap(data) {
    return new Teacher({
      name: data.name,
      joinDate: data.joinDate,
      staffType: data.staffType,
      staffCode: data.staffCode?.toString()??null,
      dob: data.dob,
      gender: data.gender,
      aadhaarNo: data.aadhaarNo,
      gmail: data.gmail,
      mobNo: data.mobNo,
      lastSchool: data.lastSchool,
      otherSchoolExp: data.otherSchoolExp,
      houseName: data.houseName,
      locality: data.locality,
      place: data.place,
      postOffice: data.postOffice,
      taluk: data.taluk,
      pinCode: data.pinCode,
      district: data.district,
      academicQualification: data.academicQualification,
      teachingQualification: data.teachingQualification,
      otherQualification: data.otherQualification,
      bankAccNo: data.bankAccNo,
      bankName: data.bankName,
      ifsc: data.ifsc,
      esicNo: data.esicNo,
      epfUan: data.epfUan,
      panNo: data.panNo,
    });
  }

  toMap() {
    const map =  {
      name: this.name,
      joinDate: this.joinDate,
      staffType: this.staffType,
      staffCode: this.staffCode,
      dob: this.dob,
      gender: this.gender,
      aadhaarNo: this.aadhaarNo,
      gmail: this.gmail,
      mobNo: this.mobNo,
      lastSchool: this.lastSchool,
      otherSchoolExp: this.otherSchoolExp,
      houseName: this.houseName,
      locality: this.locality,
      place: this.place,
      postOffice: this.postOffice,
      taluk: this.taluk,
      pinCode: this.pinCode,
      district: this.district,
      academicQualification: this.academicQualification,
      teachingQualification: this.teachingQualification,
      otherQualification: this.otherQualification,
      bankAccNo: this.bankAccNo,
      bankName: this.bankName,
      ifsc: this.ifsc,
      esicNo: this.esicNo,
      epfUan: this.epfUan,
      panNo: this.panNo,
    };

       // Convert undefined values to null
       Object.keys(map).forEach(key => {
        if (map[key] === undefined) {
          map[key] = null;
        }
      });
      return map;
  }

  static fromDataTable(row) {
    return new Teacher({
      name: utils.getFormattedTitle(row[1]),
      joinDate: row[2] ? Teacher._getDate(row[2]) : null,
      staffType: row[3],
      staffCode: row[4],
      dob: row[5] ? Teacher._getDate(row[5]) : null,
      gender: row[6],
      aadhaarNo: row[7]?.toString()??null,
      gmail: row[8],
      mobNo: row[9]?.toString()??null,
      lastSchool: row[10],
      otherSchoolExp: row[11] ? row[11].toString() : null,
      houseName: row[12],
      locality: row[13],
      place: row[14] ? row[14].toString() : null,
      postOffice: row[15],
      taluk: row[16],
      pinCode: row[17]?.toString()??null,
      district: row[18],
      academicQualification: row[19],
      teachingQualification: row[20],
      otherQualification: row[21],
      bankAccNo: row[22]?.toString()??null,
      bankName: row[23],
      ifsc: row[24]?.toString()??null,
      esicNo: row[25]?.toString()??null,
      epfUan: row[26]?.toString()??null,
      panNo: row[27]?.toString()??null,
    });
  }

  static _getDate(dateString) {
    let dateParts;
    dateString = dateString.replace(/\s/g, ''); // Remove spaces

    if (dateString.includes('/')) {
      dateParts = dateString.split('/');
    } else {
      dateParts = dateString.split('-');
    }

    const day = parseInt(dateParts[0], 10);
    const month = utils.getMonthIndex(dateParts[1]);
    const year = parseInt(dateParts[2], 10);
    const date = new Date(year, month, day);


    return Timestamp.fromDate(date); // Converts to Firestore Timestamp
  }
}

